import { Injectable, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IdentityService } from './identity.service';
import { UserService } from 'src/app/core/services/user.services';
import { Router } from '@angular/router';
import { runtimeEnv } from 'src/environments/env-loader';

let OneSignal;

@Injectable()
export class PushNotificationsService implements OnDestroy {
  constructor(private identity: IdentityService, private userService: UserService, private router: Router) {
    OneSignal = window['OneSignal'] || [];
    console.log('Push Service Init', this.identity.isPushEnabled());
  }

  init() {
    this.identity.isPushEnabled() ? this.startOneSignal() : this.initOneSignal();
  }

  async startOneSignal() {
    console.log('OneSignal Initialized');
    this.updateLocalUserProfile();
  }

  async initOneSignal() {
    OneSignal.init({
      appId: runtimeEnv.ONESIGNALAPPI,
      autoRegister: true,
      allowLocalhostAsSecureOrigin: !runtimeEnv.PRODUCTION
    });
    OneSignal.setDefaultTitle('Yacaré');
    console.log('Push Service Initialized');
    this.identity.setPushEnabled(true);
    this.checkIfSubscribed();
  }

  checkIfSubscribed() {
    OneSignal.on('subscriptionChange', (isSubscribed) => {
      console.log("The user's subscription state is now:", isSubscribed);
      this.updateLocalUserProfile();
    });
    OneSignal.isPushNotificationsEnabled(
      (isEnabled) => {
        if (!isEnabled) {
          console.log('Push notifications are not enabled yet.');
          this.subscribe();
        } else {
          console.log('Push notifications are enabled!');
          this.updateLocalUserProfile();
        }
        console.log('Initalize Listeners');
        this.listenForNotificationDisplay();
        this.listenNotificationOpened();
      },
      (error) => {
        console.log('Push permission not granted');
      }
    );
  }

  updateLocalUserProfile() {
    OneSignal.getUserId().then((userId) => {
      this.userService.registerPushId(userId);
      console.log('Push ID registered on server');
    });
  }

  subscribe() {
    OneSignal.registerForPushNotifications();
  }

  listenForNotificationDisplay() {
    OneSignal.on('notificationDisplay', (event) => {});
  }

  listenNotificationOpened() {
    OneSignal.addListenerForNotificationOpened((event) => {
      this.router.navigate(['/user/movements']);
      this.listenNotificationOpened();
    });
  }

  ngOnDestroy() {
    this.identity.setPushEnabled(false);
  }
}
